<template>
  <div class="no-crm-error-page full-height">
    <div>
      <h2 class="no-crm-error-page__heading">Wo-oh... You need to connect a CRM.</h2>
      <p class="no-crm-error-page__text">Please connect a CRM system to access this page.</p>
      <div class="no-crm-error-page__buttons">
        <button class="no-crm-error-page__button btn btn-lg btn-outline-primary mb-1" @click="goBack">Cancel</button>
        <a
          :href="lastConnectedCrm ? `/account/${lastConnectedCrm}/` : '/account/crmsettings/'"
          class="no-crm-error-page__button btn btn-lg btn-primary mb-1"
        >
          Go to CRM Settings
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'no-crm-error-page',
  props: {
    lastConnectedCrm: {
      type: String,
    },
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.no-crm-error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  &__heading {
    font-weight: bold;
    font-size: 35px;
    margin-bottom: 30px;
    @media (min-width: $breakpoint-sm) {
      font-size: 63px;
    }
  }
  &__text {
    max-width: 518px;
    font-size: 24px;
    line-height: 30px;
    margin: 0 auto 60px;
  }
  &__buttons {
    display: flex;
    gap: 32px;
    max-width: 778px;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: center;
  }
  &__button {
    min-width: 250px;
  }
}
</style>
